/* src/app/private/components/client-center/delete-center/delete-center.component.scss */
/*# sourceMappingURL=delete-center.component.css.map */
